module.exports = __webpack_public_path__ + "static/media/vidul.ec477494.jpg";